'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import 'codemirror/addon/mode/simple';
import 'codemirror/addon/display/autorefresh';
import 'codemirror/mode/clike/clike';
import 'codemirror/mode/dockerfile/dockerfile';
import 'codemirror/mode/go/go';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/php/php';
import 'codemirror/mode/powershell/powershell';
import 'codemirror/mode/python/python';
import 'codemirror/mode/ruby/ruby';
import 'codemirror/mode/shell/shell';
import 'codemirror/mode/swift/swift';
import 'codemirror/mode/xml/xml';
import { render } from 'react-dom'; // I18n initialization

import lang from 'i2l?query=sporks!../lang/en.lyaml';
import BasicPublicI18nSetup from 'I18n/init/setup/BasicPublicI18nSetup';
import { emptyAuthData } from 'developer-docs-shared-components/utils/authUtils';
import UIApplication from 'UIComponents/app/UIApplication';
import { createBrowserHistory } from 'history';
import { setUsageTracker } from 'developer-docs-shared-components/tracking/usageTracker'; // Rhumb

import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4'; // Redux

import { Provider } from 'react-redux';
import configureStore from './utils/configureStore'; // Configure the router

import { Router } from 'react-router-dom';
import { getPublicRootUrl } from './utils/urls';
import Routes from './Routes';
export default class App {
  constructor({
    usageTracker
  }) {
    setUsageTracker(usageTracker);
  }

  startWithNoAuth() {
    this.startRedux();
    return BasicPublicI18nSetup.setup({
      lang
    }).then(() => {
      this.startRouter();
    });
  }

  startRedux() {
    const authData = emptyAuthData;
    this.store = configureStore({
      auth: Object.assign({}, authData)
    });
  }

  startRouter() {
    const basename = getPublicRootUrl();
    const history = createBrowserHistory({
      basename
    });
    render( /*#__PURE__*/_jsx(UIApplication, {
      name: "endpoint-reference-ui",
      children: /*#__PURE__*/_jsx(Provider, {
        store: this.store,
        children: /*#__PURE__*/_jsx(RhumbProvider, {
          config: rhumbConfig,
          history: historyAdapter(history),
          children: /*#__PURE__*/_jsx(Router, {
            history: history,
            children: /*#__PURE__*/_jsx(Routes, {})
          })
        })
      })
    }), document.getElementsByClassName('page')[0]);
  }

}